var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _stateSubscription, _states, _subscriptions, _updates, _workflow;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet2(e, t) { var r = _classPrivateFieldGet(t, e); return _classApplyDescriptorGet(e, r); }
function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
function _classPrivateFieldSet(e, t, r) { var s = _classPrivateFieldGet(t, e); return _classApplyDescriptorSet(e, s, r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classApplyDescriptorSet(e, t, l) { if (t.set) t.set.call(e, l);else { if (!t.writable) throw new TypeError("attempted to set read only private field"); t.value = l; } }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { Subject, Subscription } from 'rxjs';
import { filter, distinctUntilKeyChanged } from 'rxjs/operators';
import Service, { inject as service } from '@ember/service';
import { set } from '@ember/object';
import { Relationship } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
import { updateLogger } from '@banking/ui/lib/workflow/update-logger';
import { createEmit, createSelect } from '@banking/ui/lib/workflow-ember/decorators';
import connect from '@banking/ui/lib/workflow-ember/connect';
import workflow, { createState, initializeAction, setActiveSettingAction, Setting } from '@banking/ui/workflows/card-settings';
import assert from '@banking/ui/utils/assert';
import { InitializationReason, initializeAction as initializeBillingAddressAction, toggleModalAction } from '@banking/ui/workflows/card-settings/billing-address';
import { initializeAction as initializeResetPinAction, toggleModalAction as toggleResetPinModalAction } from '@banking/ui/workflows/card-settings/set-pin';
import { CancellationType, userClickCloseModalAction } from '@banking/ui/workflows/card-settings/cancel-card';
import { toggleModalAction as toggleActivateCardModalAction } from '@banking/ui/workflows/debit-card-activation';
import analytics from '@banking/ui/workflows/card-settings/analytics/analytics';
import { isCardExpired, isCardExpiring, isCardTerminated } from '../utils/card-settings-utils';
const SERVICE_REGISTRY_KEY = 'card-settings';
let CardSettingsState = (_dec = service('debit-card-activation-modal'), _dec2 = service('bbfrontend/v1/checking'), _dec3 = service('card-management/billing-address'), _dec4 = service('bb-debit/card-management-service'), _dec5 = service('card-management/cancel-card-modal'), _dec6 = service('card-management/reset-pin-modal'), _class = (_stateSubscription = /*#__PURE__*/new WeakMap(), _states = /*#__PURE__*/new WeakMap(), _subscriptions = /*#__PURE__*/new WeakMap(), _updates = /*#__PURE__*/new WeakMap(), _workflow = /*#__PURE__*/new WeakMap(), class CardSettingsState extends Service {
  constructor(...args) {
    super(...args);
    _classPrivateFieldInitSpec(this, _stateSubscription, {
      writable: true,
      value: null
    });
    _classPrivateFieldInitSpec(this, _states, {
      writable: true,
      value: new Subject()
    });
    _classPrivateFieldInitSpec(this, _subscriptions, {
      writable: true,
      value: new Subscription()
    });
    _classPrivateFieldInitSpec(this, _updates, {
      writable: true,
      value: new Subject()
    });
    _classPrivateFieldInitSpec(this, _workflow, {
      writable: true,
      value: void 0
    });
    _defineProperty(this, "state", createState());
    _initializerDefineProperty(this, "activateCardModalState", _descriptor, this);
    _initializerDefineProperty(this, "bbFrontendV1CheckingService", _descriptor2, this);
    _initializerDefineProperty(this, "billingAddressState", _descriptor3, this);
    _initializerDefineProperty(this, "bizbankApi", _descriptor4, this);
    _initializerDefineProperty(this, "cardManagementService", _descriptor5, this);
    _initializerDefineProperty(this, "cancelCardModalState", _descriptor6, this);
    _initializerDefineProperty(this, "dataApi", _descriptor7, this);
    _initializerDefineProperty(this, "intl", _descriptor8, this);
    _initializerDefineProperty(this, "resetPinModalState", _descriptor9, this);
    _initializerDefineProperty(this, "features", _descriptor10, this);
    _initializerDefineProperty(this, "router", _descriptor11, this);
    _initializerDefineProperty(this, "sentry", _descriptor12, this);
    _classPrivateFieldSet(this, _stateSubscription, _classPrivateFieldGet2(this, _states).subscribe({
      next: state => set(this, 'state', state),
      error: error => this.sentry.captureException(error)
    }));
    _classPrivateFieldGet2(this, _updates).subscribe(updateLogger('Card settings'));
    analytics(_classPrivateFieldGet2(this, _updates)).subscribe(params => this.dataApi.track(...params));
    this.reset();
  }
  willDestroy() {
    this.deinitialize();
    _classPrivateFieldGet2(this, _subscriptions).unsubscribe();
    super.willDestroy();
  }
  reset() {
    _classPrivateFieldGet2(this, _subscriptions).unsubscribe();
    _classPrivateFieldSet(this, _subscriptions, new Subscription());
    _classPrivateFieldSet(this, _workflow, workflow(createState(), this.context));
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).states.subscribe({
      next: next => _classPrivateFieldGet2(this, _states).next(next),
      error: error => this.sentry.captureException(error)
    }));
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).updates.subscribe(next => _classPrivateFieldGet2(this, _updates).next(next)));
    // set setting to none when modal close
    _classPrivateFieldGet2(this, _subscriptions).add(this.billingAddressState.states.pipe(distinctUntilKeyChanged('isOpen'), filter(({
      isOpen
    }) => !isOpen)).subscribe(() => {
      this.emit(setActiveSettingAction(Setting.None));
    }));
    _classPrivateFieldGet2(this, _subscriptions).add(this.resetPinModalState.states.pipe(distinctUntilKeyChanged('isOpen'), filter(({
      isOpen
    }) => !isOpen)).subscribe(() => {
      this.emit(setActiveSettingAction(Setting.None));
    }));
    _classPrivateFieldGet2(this, _subscriptions).add(this.cancelCardModalState.states.pipe(distinctUntilKeyChanged('modalOpen'), filter(({
      modalOpen
    }) => !modalOpen)).subscribe(() => {
      this.emit(setActiveSettingAction(Setting.None));
    }));
    _classPrivateFieldGet2(this, _subscriptions).add(this.activateCardModalState.states.pipe(distinctUntilKeyChanged('isOpen'), filter(({
      isOpen
    }) => !isOpen)).subscribe(() => {
      this.emit(setActiveSettingAction(Setting.None));
    }));
  }
  emit(action) {
    _classPrivateFieldGet2(this, _workflow).emit(action);
  }
  openBillingAddressModal(unitToken) {
    const {
      card
    } = this.state;
    const expiringCardToken = card && isCardExpiring(card) ? card.id : undefined;
    this.billingAddressState.emit(initializeBillingAddressAction({
      expiringCardToken,
      unitToken,
      reason: InitializationReason.CLICK_EDIT_ADDRESS
    }));
  }
  openResetPinModal(cardToken) {
    this.resetPinModalState.emit(initializeResetPinAction(cardToken));
  }

  /** *
   * There are 4 cancellation flows:
   * 1. If the current user is not the card holder, we're canceling an authorized user's card.
   * 2. If the current user is the card holder and their card is terminated or expired, the only option is account termination.
   * 3. If the current user is the card holder and their card is not terminated, they can either cancel their account/card or reorder a new card.
   * 4. Same as 3, but opens the flow as if user selected "Never received card" option on the card cancellation reason selection
   */
  openCancelCardModal(cancellationTypeArg = undefined) {
    const card = this.state.card;
    const cardCustomization = this.state.cardCustomization;
    const unitToken = this.router.currentRoute.params.unit_token;
    assert(card != null);
    assert(cardCustomization != null);
    assert(unitToken != null);
    let cancellationType;
    if (cancellationTypeArg) {
      cancellationType = cancellationTypeArg;
    } else if (card.relationship.includes(Relationship.RELATIONSHIP_CARDHOLDER)) {
      cancellationType = isCardExpired(card) || isCardTerminated(card) ? CancellationType.AccountHolderAccount : CancellationType.AccountHolderCard;
    } else {
      cancellationType = CancellationType.AuthorizedUserCard;
    }
    const balanceId = card.balanceId;
    this.cancelCardModalState.openModal(balanceId, card, cardCustomization, cancellationType, unitToken,
    // on successful cancel card, refetch card
    () => _classPrivateFieldGet2(this, _workflow).emit(initializeAction(card.id, unitToken)));
  }
  openCardActivationModal() {
    const card = this.state.card;
    const unitToken = this.router.currentRoute.params.unit_token;
    assert(card != null);
    assert(unitToken != null);
    this.activateCardModalState.openModal(unitToken, card.id,
    // on successful cancel card, refetch card
    () => _classPrivateFieldGet2(this, _workflow).emit(initializeAction(card.id, unitToken)));
  }
  closeActiveModal() {
    const {
      activeSetting
    } = this.state;
    switch (activeSetting) {
      case Setting.ActivateCard:
        {
          if (this.activateCardModalState.state.isOpen) {
            return this.activateCardModalState.emit(toggleActivateCardModalAction(false));
          }
          break;
        }
      case Setting.BillingAddress:
        return this.billingAddressState.emit(toggleModalAction(false));
      case Setting.CancelCard:
        {
          if (this.cancelCardModalState.state.modalOpen) {
            return this.cancelCardModalState.emit(userClickCloseModalAction());
          }
          break;
        }
      case Setting.ResetPin:
        {
          if (this.activateCardModalState.state.isOpen) {
            return this.resetPinModalState.emit(toggleResetPinModalAction(false));
          }
          break;
        }
      case Setting.None:
    }
  }
  get states() {
    return _classPrivateFieldGet2(this, _states).asObservable();
  }
  deinitialize() {
    _classPrivateFieldGet2(this, _subscriptions).unsubscribe();
    _classPrivateFieldGet2(this, _stateSubscription)?.unsubscribe();
  }
  get context() {
    return {
      cardManagementService: this.cardManagementService.client,
      getCardCustomization: this.bizbankApi.client.getCardCustomization.bind(this.bizbankApi.client),
      getCheckingDirectDepositAccount: this.bbFrontendV1CheckingService.client.getCheckingDirectDepositAccount.bind(this.bbFrontendV1CheckingService.client),
      isFeatureEnabled: this.features.isEnabled.bind(this.features),
      router: this.router,
      sentry: this.sentry
    };
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "activateCardModalState", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1CheckingService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "billingAddressState", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bizbankApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "cardManagementService", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cancelCardModalState", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "resetPinModalState", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CardSettingsState as default };
export const select = createSelect(SERVICE_REGISTRY_KEY);
export const emit = createEmit(SERVICE_REGISTRY_KEY);
export const workflowComponent = connect(SERVICE_REGISTRY_KEY);